import React from "react";
import Dots from "../../../../assets/Local_shoping_dots.png";
import KayakRentals_Top from "../../../../assets/Kayak_Rentals_Top.png";
import KayakRentals_Bottom from "../../../../assets/Kayak_Rentals_Bottom.png";
import Classes from "./Style.module.css";

const Index = () => {
  return (
    <div className={Classes.section4}>
      <div className={Classes.section4_left}>
        <h1>Explore Places</h1>
        <h2>Kayak Rentals</h2>
        <p>
          <a href="#">World Within Kayak Rentals </a> is located here at the
          Ogunquit River Inn in the heart of the Rachel Carson Wildlife Refuge.
          The safe, quiet, beautiful Ogunquit river and it’s maze-like estuaries
          that lead down to the Atlantic ocean. Guests staying at Ogunquit River
          Inn receive discounted rates on rentals.
        </p>
        <div className={Classes.section_button}>
          <button className="btn_primary alter" style={{ marginRight: "2rem" }}>
            CALL NOW
          </button>
          <button className="btn_primary">BOOK NOW</button>
        </div>
      </div>
      <div className={Classes.section4_right}>
        <div>
          <img
            className={`${Classes.section4_right_image}`}
            alt="Hotel"
            src={KayakRentals_Bottom}
          />
          <img className={Classes.section4_right_dots} alt="Dots" src={Dots} />
          <img
            className={`${Classes.section4_right_image} ${Classes.second}`}
            alt="Hotel Alt"
            src={KayakRentals_Top}
          />
        </div>
      </div>
    </div>
  );
};

export default Index;
